import {
  cloneElement,
  ReactElement,
  ReactNode,
  useEffect,
  useRef,
  useState,
} from 'react';

import { Tooltip, TooltipProps } from '@cast/design-system';

type Props = {
  children: ReactElement<{ onClick?: (event: MouseEvent) => void }>;
  title: ReactNode;
  tooltipProps?: Partial<TooltipProps>;
  duration?: number;
};

export const OnClickMessagePopper = ({
  children,
  title,
  tooltipProps,
  duration = 2000,
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const timeoutRef = useRef<number>(undefined);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return (
    <Tooltip
      disableFocusListener
      disableHoverListener
      disableTouchListener
      title={title}
      open={isOpen}
      arrow
      placement="top"
      {...tooltipProps}
    >
      {cloneElement(children, {
        onClick: (e: MouseEvent) => {
          children.props.onClick?.(e);
          setIsOpen(true);
          if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = undefined;
          }
          setTimeout(() => {
            setIsOpen(false);
            timeoutRef.current = undefined;
          }, duration);
        },
      })}
    </Tooltip>
  );
};
